import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchSummary(action) {
  const { filtersString, sortBy } = action.payload;
  try {
    const response = yield call(API.fetchTestingAnalyticsSummary, {
      filtersString,
      sortBy
    });
    yield put(actions.fetchSummarySuccess(response.data));
  } catch (error) {
    console.error('API Error:', error);
    const errorPayload = {
      message: error.message || 'An error occurred',
      status: error.response?.status || 500,
      statusText: error.response?.statusText || 'Internal Server Error'
    };
    yield put(actions.fetchSummaryFailure(errorPayload));
  }
}

export function* testingAnalyticsSummarySaga() {
  yield takeLatest(actions.fetchSummary.type, handleFetchSummary);
}